import { useQuery } from "@tanstack/react-query";
import { companyAPI } from "@/lib/api";
import type { CompanyProfile } from "@/features/settings/lib/settingsApi";
import { usePermission } from "@/hooks/usePermission";

/** React Query key for `/company/profile` (tenant company from JWT). */
export const COMPANY_PROFILE_QUERY_KEY = ["company", "profile"];

/**
 * Cached tenant company profile; prefer this over ad-hoc `companyAPI.getProfile()` in pages.
 * Skipped for users without `company.read` (the endpoint would 403); callers fall back to defaults.
 */
export function useCompanyProfile(options?: { enabled?: boolean }) {
	const canReadCompany = usePermission("company.read");
	return useQuery({
		queryKey: COMPANY_PROFILE_QUERY_KEY,
		queryFn: () => companyAPI.getProfile() as Promise<CompanyProfile>,
		enabled: canReadCompany && options?.enabled !== false,
	});
}
